// Pagination
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginationList from './PaginationList';
import { getPager } from '../../reducers/reducer-functions';

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.defaultProps = {
      initialPage: 1,
      pageSize: 12,
    };

    this.state = {
      pager: {},
    };

    this.setPage = this.setPage.bind(this);
    this.setPageFromUser = this.setPageFromUser.bind(this);
  }

  componentDidMount() {
    // set page if items array isn't empty — do not scroll (initial paint)
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage, { scroll: false });
    }
  }

  componentDidUpdate(prevProps) {
    // reset page if items array has changed (filter/search) — do not scroll (avoids search jump)
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage, { scroll: false });
    }
  }

  setPageFromUser(page) {
    // User pagination click — scroll listing to top
    this.setPage(page, { scroll: true });
  }

  setPage(page, options = {}) {
    const { items, pageSize } = this.props;
    const { scroll: shouldScroll = false } = options;
    const { totalPages } = this.state.pager;

    // Allow first paint when pager is empty; otherwise guard invalid pages
    if (page < 1 || (typeof totalPages === 'number' && page > totalPages)) {
      return;
    }

    // get new pager object for specified page
    const pager = getPager(items.length, page, pageSize);

    // get new page of mediaItems from mediaItems array
    const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

    // update state
    this.setState({ pager });

    this.props.onChangePage(pageOfItems, { scroll: shouldScroll });
  }

  render() {
    if (!this.state.pager.pages || this.state.pager.pages.length <= 1) {
      return null;
    }

    return (
      <PaginationList pager={this.state.pager} setPage={this.setPageFromUser} />
    );
  }
}

Pagination.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onChangePage: PropTypes.func.isRequired,
  initialPage: PropTypes.number,
  pageSize: PropTypes.number,
};

export default Pagination;
